import React, { useState } from "react";
import { BiSearch } from "react-icons/bi";
import ATMTab from "src/components/UI/atoms/ATMTab/ATMTab";
import ATMInputAdormant from "src/components/UI/atoms/formFields/ATMInputAdormant/ATMInputAdormant";
import NotesTabWrapper from "./Tabs/NotesTab/NotesTabWrapper";
import TaskTabListWrapper from "./Tabs/TaskTab/TaskTabListWrapper";
import EmailsTabWrapper from "./Tabs/EmailsTab/EmailsTabWrapper";
import CallsTabWrapper from "./Tabs/CallsTab/CallsTabWrapper";
import MeetingTabWrapper from "./Tabs/MeetingTab/MeetingTabWrapper";
import SMSTabWrapper from "./Tabs/SMSTab/SMSTabWrapper";

const Activities = () => {
  const [searchValue, setSearchValue] = useState<any>();
   
  const [selectedTab, setSelectedTab] = useState<any>("task");

  const tab: any[] = [
    {
      label: "Task",
      path: "task",
      onClick: () => {
        setSelectedTab("task");
      },
    },
    {
      label: "Notes",
      path: "notes",
      onClick: () => {
        setSelectedTab("notes");
      },
    },
    {
      label: "Emails",
      path: "emails",
      onClick: () => {
        setSelectedTab("emails");
      },
    },
    {
      label: "Calls",
      path: "calls",
      onClick: () => {
        setSelectedTab("calls");
      },
    },
    {
      label: "Meetings",
      path: "meetings",
      onClick: () => {
        setSelectedTab("meetings");
      },
    },
   
    {
      label: "SMS",
      path: "sms",
      onClick: () => {
        setSelectedTab("sms");
      },
    },
  ];

  return (
    <div>
      <div className="p-4">
        <div className="w-[200px]">
          <ATMInputAdormant
            name=""
            value={searchValue}
            onChange={setSearchValue}
            adormant={<BiSearch />}
            adormantProps={{
              position: "start",
              extraClasses: "bg-white border-0",
            }}
            inputProps={{ className: "bg-white" }}
            placeholder="Search activities"
          />
        </div>
        <div className="flex flex-col h-full overflow-hidden">
          <div className="sticky top-0 md:p-4 p-2 bg-white z-10 md:flex block ">
            <div className="">
              <ATMTab
                tabs={tab}
                selected={(tab: any) => tab.path === selectedTab}
                childrenLabel={selectedTab}
                children={<></>}
              />
            </div>
          </div>
          {/* {renderTabContent()} */}

          <div>
            {selectedTab && (
              <div className=" p-1">
                {selectedTab === "task" && (
                  <div>
                    <TaskTabListWrapper />
                  </div>
                )}

                {selectedTab === "notes" && (
                  <div>
                    <NotesTabWrapper />
                  </div>
                )}
                {selectedTab === "emails" && (
                  <div>
                    <EmailsTabWrapper />
                  </div>
                )}
                {selectedTab === "calls" && <CallsTabWrapper />}
                {selectedTab === "meetings" && (
                  <div>
                    <MeetingTabWrapper />
                  </div>
                )}

                {selectedTab === "sms" && <SMSTabWrapper />}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Activities;
